export const TOKEN_DECIMALS = 18;

export enum Networks {
    MATIC = 80001,
}

export const DEFAULD_NETWORK = Networks.MATIC;
